<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Company Menu" @click="$router.push('/company')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" fab small @click="showAdd">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elevation-1 mt-10">
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>                    
                </v-toolbar>
                <v-data-table
                    :headers="isMobile ? [] : header"
                    :items="annoucements_filtered" 
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="header.length" class="pa-1">
                                <v-card class="elevation-1" @click="viewDetails(props.item)">
                                    <v-toolbar flat height="42">
                                        <b>{{ props.item.title }}</b>
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5 mb-1">
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="caption grey--text text--darken-1">Category</div>
                                                    <v-chip small class="user-chip-container" :style="`background-color:${props.item.backgroundColor}`">
                                                        <span class="white--text">{{ props.item.categoryName }}</span>
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="caption grey--text text--darken-1">Type</div>
                                                    <v-chip small class="user-chip-container">
                                                        <span>{{ props.item.typeName }}</span>
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="caption grey--text text--darken-1">Status</div>
                                                    <div :class="props.item.statusColor">{{ props.item.status }}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>
                        
                        <!-- desktop view -->
                        <tr v-else @click="viewDetails(props.item)" title="Click to view details" class="clickable">
                            <td>{{ props.item.title }}</td>
                            <td>
                                <v-chip small class="user-chip-container" :style="`background-color:${props.item.backgroundColor}`">
                                    <span class="white--text">{{ props.item.categoryName }}</span>
                                </v-chip>
                            </td>
                            <td>{{ props.item.typeName }}</td>
                            <td>
                                <span :class="props.item.statusColor">{{ props.item.status }}</span>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" persistent width="900">
            <add-edit ref="refAddEdit" :dialogAddEdit.sync="dialogAddEdit" @send="getPulicNotifications"></add-edit>
        </v-dialog>
    </v-layout> 
</template>

<script>

import companyAnnouncementsApi from '@/api/companyannouncements'
import awsS3Helper from '@/helpers/aws-s3'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'

export default {     
    name: 'CompanyAnnouncements',
    metaInfo: {
        title: 'Company Announcements',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Company Announcements' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'team-chips': () => import("@/components/Common/TeamsChip"),
        'add-edit': ()=> import('@/components/CompanyAnnouncements/AddEditCompanyAnnouncement')
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            header: [
                {text:'Title', align: 'left', value:'title',  width:'25%', sortable:true},
                {text:'Category', align: 'left', value:'categoryName', width:'25%', sortable:true},
                {text:'Type', align: 'left', value:'typeName', width:'25%', sortable:true},
                {text:'Status', align: 'left', value:'status',  width:'25%', sortable:true},
            ],
            search: null,
            error: false,
            errorMessage: '',
            loading: false,
            dialogAddEdit: false,
            annoucements: []
        }
    },
    methods: {
        viewDetails(data) {
            this.$router.push(`/company/announcements/${data.companyAnnouncementId}`)
        },        
        showAdd() {
            this.$refs.refAddEdit.setAdd()
            this.dialogAddEdit = true
        },
        async getPulicNotifications() {
            try {
                this.loading = true
                const response = await companyAnnouncementsApi.getAll()
                if (response && response.status == 200) {
                    this.annoucements = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'Company Announcements',
            headerPageTitle: ''
        })

        this.getPulicNotifications()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        annoucements_filtered() {
            var temp = this.annoucements

            //search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase();

                temp = temp.filter(item => {
                    const categoryNameMatch = item.categoryName.toLowerCase().includes(searchLower)                    
                    const typeNameMatch = item.typeName.toLowerCase().includes(searchLower)       
                    const detailsMatch = item.details.toLowerCase().includes(searchLower)                 
                    const displayStartDateMatch = item.displayStartDate.includes(searchLower)
                    const effectiveDateMatch = item.effectiveDate.includes(searchLower)
                    const expirationDateMatch = item.expirationDate.includes(searchLower)
                    const statusMatch = item.status.includes(searchLower)

                    const teamsMatch = Array.isArray(item.teams)
                        ? item.teams.join(', ').toLowerCase().includes(searchLower)
                        : false

                    return categoryNameMatch || 
                            typeNameMatch || 
                            detailsMatch || 
                            displayStartDateMatch || 
                            effectiveDateMatch ||
                            expirationDateMatch ||
                            statusMatch ||
                            teamsMatch 
                })
            }
            return temp
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>